import { render, staticRenderFns } from "./ShippingAdress.vue?vue&type=template&id=07b58d34&scoped=true"
import script from "./ShippingAdress.vue?vue&type=script&lang=js"
export * from "./ShippingAdress.vue?vue&type=script&lang=js"
import style0 from "./ShippingAdress.vue?vue&type=style&index=0&id=07b58d34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b58d34",
  null
  
)

export default component.exports